const STEP_ITEMS = [
    ['1', '대상 평가 선택'],
    ['2', '변경 내용 입력'],
    ['3', '영향 항목 확인'],
]

export function MaintenanceStepIndicator() {
    return (
        <div className='grid gap-3 md:grid-cols-3'>
            {STEP_ITEMS.map(([step, label], index) => (
                <div
                    key={step}
                    className={`border-border bg-card flex items-center gap-3 rounded-md border px-4 py-3 ${
                        index === 0 ? 'border-primary bg-accent' : ''
                    }`}>
                    <span
                        className={`grid size-7 shrink-0 place-items-center rounded-sm text-sm font-bold ${
                            index === 0
                                ? 'bg-primary text-primary-foreground'
                                : 'bg-muted text-muted-foreground'
                        }`}>
                        {step}
                    </span>
                    <span className='text-foreground text-sm font-semibold'>
                        {label}
                    </span>
                </div>
            ))}
        </div>
    )
}
